import React from 'react';
import {
  IconButton,
  IconCheckMarkSolid,
  IconPeerReviewSolid,
  IconCheckMarkIndeterminateLine,
  IconXLine,
  IconCommentsOnLine,
} from '@instructure/ui';
import { useEffect, useState } from 'react';
import { getStore, useCheckinStore } from '../../../stores/StoreContext';
/**
 * @function ItemIcon
 *
 * @description Renders an icon representing the status of a check-in item.
 * The icon changes based on the current status of the item, which can be
 * 'accept', 'accept-with-comment', 'reject', 'optout', or 'default'. Each
 * status is associated with a specific icon, color, and label.
 *
 * @param {Object} item - The check-in item for which the icon is rendered.
 *
 * @returns {ReactElement} - The rendered icon button representing the item's status.
 */

const ItemIcon = ({ item }) => {
  const CheckinStore = getStore('checkinStore');

  const [icon, setIcon] = useState();

  const icons = {
    accept: {
      color: 'success',
      icon: <IconCheckMarkSolid />,
      label: 'Accepted',
    },
    'accept-with-comment': {
      color: 'success',
      icon: <IconCommentsOnLine />,
      label: 'Accpeted with comments',
    },
    reject: { color: 'danger', icon: <IconXLine />, label: 'Rejected' },
    optout: {
      color: 'success',
      icon: <IconCheckMarkIndeterminateLine />,
      label: 'opt-out',
    },
    default: {
      color: 'secondary',
      icon: <IconPeerReviewSolid />,
      label: 'Needs Review',
    },
  };

  const status = useCheckinStore((state) => state.items[item.id].status);

  useEffect(() => {
    if (CheckinStore.items[item.id].status) {
      setIcon(icons[CheckinStore.items[item.id].status]);
    } else {
      setIcon(icons.default);
    }
  }, [status]);

  return (
    <>
      {icon && (
        <IconButton
          as="div"
          color={icon.color}
          screenReaderLabel={icon.label}
          shape="circle"
          size="small"
          cursor="arrow"
        >
          {icon.icon}
        </IconButton>
      )}
    </>
  );
};

export default ItemIcon;
